<div class="web-layout">
  <router-outlet></router-outlet>
  <finfra-footer-component></finfra-footer-component>
</div>
